import { render, staticRenderFns } from "./EfetivarProvisaoProcedimento.vue?vue&type=template&id=7039a50a&scoped=true"
import script from "./EfetivarProvisaoProcedimento.vue?vue&type=script&lang=js"
export * from "./EfetivarProvisaoProcedimento.vue?vue&type=script&lang=js"
import style0 from "./EfetivarProvisaoProcedimento.vue?vue&type=style&index=0&id=7039a50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7039a50a",
  null
  
)

export default component.exports